__turbopack_context__.v({
  "root": "RingProProductCarousel-module__Fdeyma__root",
});
